import { useState, useEffect, useRef } from "react";
import Brand from "./Brand";
import SlCloudNav from "../brands/servicelad/SlCloudNav";
import { goToNavHref } from "../utils/nav";
import { navLinksForBrand } from "../config/navLinks.js";

export default function SiteNav({ brand }) {
  if (brand.key === "servicelad") {
    return <SlCloudNav brand={brand} />;
  }
  return <LegacySiteNav brand={brand} />;
}

function LegacySiteNav({ brand }) {
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onClick);
    return () => document.removeEventListener("pointerdown", onClick);
  }, [open]);

  const handleNav = (href) => {
    setOpen(false);
    goToNavHref(href);
  };

  const allLinks = navLinksForBrand(brand);

  return (
    <>
      <header className="sitenav-header" ref={navRef}>
        <div className="wrap sitenav-bar">
          <Brand brand={brand} />
          <button
            className={`menu-trigger${open ? " is-open" : ""}`}
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            <span className="trigger-label">{open ? "Close" : "Menu"}</span>
            <span className="trigger-burger" aria-hidden="true">
              <i /><i /><i />
            </span>
          </button>
        </div>
        <div className={`nav-panel${open ? " is-open" : ""}`}>
          <nav className="nav-panel-links">
            {allLinks.map((link) => (
              <button
                key={link.label}
                className={`nav-panel-link${link.primary ? " is-primary" : ""}`}
                onClick={() => handleNav(link.href)}
                type="button"
              >
                <span>{link.label}</span>
                <span className="nav-link-arrow" aria-hidden="true">→</span>
              </button>
            ))}
          </nav>
          <div className="nav-panel-foot">
            <span>{brand.name}</span>
            <span>{brand.email}</span>
          </div>
        </div>
      </header>
    </>
  );
}
